/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { VendingMachinePageService } from '@pages/VendingMachinePage/services';

const getSrv = () => {
  return vappContainer.get<VendingMachinePageService>(
    VendingMachinePageService.displayName
  );
};

export const getTime = async (context: any, event: any) => {
  const currentState = 'GET_TIME';
  const method = 'getTime';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const time = await srv.agent.getTime();
      if (time) {
        return resolve({
          key: 'RENDER_TIME',
          value: {
            ...(time || {}),
          },
        });
      } else {
        const msg = 'get Time not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_TIME_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_TIME_ERROR',
        value: err?.message,
      });
    }
  });
};
